export default "__VITE_ASSET__Dqqx_qKs__"